import { Directive, HostListener, Host } from '@angular/core';
import { DropdownLinkDirective } from './dropdown-link.directive';

@Directive({
  selector: '[appDropdownToggle]'
})
export class DropdownAnchorDirective {

  constructor(@Host() protected navlink: DropdownLinkDirective) {console.log('inside directive constructor==>',navlink) }

  @HostListener('click', ['$event'])
  onClick(e: any) {
    this.navlink.toggle();
  }
}